export default "__VITE_ASSET__gPxq9cqX__"